import React from "react";
import { getSmoothStepPath } from "reactflow";

export default function PlaybookEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  markerEnd,
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <path
        id={id}
        style={{ strokeWidth: "2px", stroke: "rgb(80, 81, 88)" }}
        className="react-flow__edge-path EdgeLabel"
        d={edgePath}
        markerEnd={markerEnd}
      />
      <text stroke="white">
        <textPath href={`#${id}`} startOffset="50%" textAnchor="middle">
          {data.label}
        </textPath>
      </text>
    </>
  );
}
